import  request  from '../utils/request'
import  { post,get }  from '../utils/request'
import config from '@/config/index'
/**
 * 假设接口http://www.baidu.com/api/XX/XXXX/XXXXXXX/XXXXXXXXX
 * export const apiAddress = p => post('api/XX/XXXX/XXXXXXX/XXXXXXXXX', p); //p是我们请求接口时携带的参数对象
 * 在页面中 import { apiAddress } from '@/api/user';// 导入我们的api接口
 * onLoad() { //方法名
 *      //调用api接口，并且提供了两个参数
 *      apiAddress({
 *          type: 0,
 *          sort: 1
 *          }).then(res => {
 *              // 获取数据成功后的其他操作
 *                   ………………
 *     })
 *  }
 */
// 登录
export const getVerifyCodeImg = p => get(config.devProxy+`/author/Logon/getVerifyCodeImg?${Math.random() * 1000}`, p);
// 登录
export const login = p => post(config.devProxy+'/mobile/cjpl/CjplClass/mobileLoginH5Ajax?type=8082', p);
// 登录
// export function login(data) {
//     alert(data.username)
//     return request({
//         url: '/rdmobile/caseaction//mobileLoginAjax',
//         method: 'post',
//         data
//     })
// }
// 获取用户信息
export function getInfo(token) {
    return request({
        url: '/user/info',
        method: 'get',
        params: {token}
    })
}

export function logout() {
    return request({
        url: '/bopmain/MainPage/logout',
        method: 'post'
    })
}


export function resetToken() {
    return request({
        url: '/mobile/cjpl/CjplClass/mobileLoginAjax?type=8082',
        method: 'post'
    })
}

// 登录
export function getUserInfoAjax(data) {
    return request({
        url: '/mobile/cjpl/CjplClass/getUserInfoAjax',
        method: 'post',
        data
    })
}